import script from "./ButtonComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonComponent.vue?vue&type=script&setup=true&lang=js"

import "./ButtonComponent.vue?vue&type=style&index=0&id=7af6bbc4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7af6bbc4"]])

export default __exports__